import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import { navigateLoginUrl } from './utils';
import Login from './views/Login';
import PageNotFound from './views/PageNotFound';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/',
      name: 'home',
      redirect: '/contracts/created',
    },
    {
      path: '/status',
      name: 'statistics',
      component: () => import('./views/SystemStatus'),
    },
    {
      path: '/customers',
      name: 'customersList',
      component: () => import('./views/Customers'),
    },
    {
      path: '/customers/:customerId',
      name: 'customerPage',
      component: () => import('./views/Customers/Detail'),
    },
    {
      path: '/contract/:internalId',
      name: 'contractDetails',
      component: () => import('./views/Contracts/Detail'),
    },
    {
      path: '/contract',
      name: 'contractForm',
      component: () => import('./views/Contracts/ContractForm'),
    },
    {
      path: '/contracts/:status?',
      name: 'contractList',
      component: () => import('./views/Contracts'),
    },
    {
      path: '/bankdetails/:status',
      name: 'bankdetailsList',
      component: () => import('./views/BankDetails'),
    },
    {
      path: '/employees',
      name: 'usersList',
      component: () => import('./views/Employees'),
    },
    {
      path: '/bgc',
      name: 'bgcList',
      component: () => import('./views/BgcFiles'),
    },
    {
      path: '/invoices',
      name: 'invoicesList',
      component: () => import('./views/Invoices'),
    },
    {
      path: '/debts',
      name: 'debtsList',
      component: () => import('./views/Debts'),
    },
    {
      path: '/repayments',
      name: 'repaymentsList',
      component: () => import('./views/Repayments'),
    },
    {
      path: '/campaigns',
      name: 'campaignList',
      component: () => import('./views/Campaigns'),
    },
    {
      path: '/periods',
      name: 'billingPeriodsList',
      component: () => import('./views/BillingPeriods'),
    },
    {
      path: '/pdf',
      name: 'pdfTemplates',
      component: () => import('./views/PdfList'),
    },
    {
      path: '/reports',
      name: 'reports',
      component: () => import('./views/Reports'),
    },
    {
      path: '/billing-dashboard',
      name: 'billingDashboard',
      component: () => import('./views/BillingDashboard'),
    },
    {
      path: '/technical/version',
      name: 'appInfo',
      component: () => import(/* webpackChunkName: "@page-app-info" */ './views/AppInfo.vue'),
    },
    {
      path: '*',
      component: PageNotFound,
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.isPublic) {
    next();
    return;
  }

  if (to.name === 'login' || to.name === 'appInfo') {
    next();
    return;
  }

  const authorized = await store.dispatch('refreshAuthWait');
  if (authorized) {
    next();
  } else {
    navigateLoginUrl();
  }
});

router.afterEach((to) => {
  // set trail to previous route to be able to restre navigation
  // e.g after session expiration or forced logout
  router.previousRoute = to;
});

export default router;
